<template>
  <div
    class="flex h-5 cursor-default items-center gap-2 overflow-x-hidden overflow-y-hidden text-6pt"
  >
    <template v-for="(fol, i) in fieldsOfLaw" :key="fol.id">
      <i-heroicons-chevron-right-20-solid
        v-if="i > 0"
        class="h-4 w-4 shrink-0"
      />
      <component
        :is="isMainContent ? 'h2' : 'span'"
        v-if="i === fieldsOfLaw.length - 1"
        class="truncate transition-all hover:shrink-0"
      >
        {{ fol.name }}
      </component>
      <span
        v-else
        class="truncate transition-all hover:shrink-0"
        :class="i === 0 ? 'shrink-0' : 'shrink-1'"
      >
        {{ fol.name }}
      </span>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { IFieldOfLawWithParents } from "~/models/IFieldOfLaw";

const props = defineProps<{
  fieldOfLaw?: IFieldOfLawWithParents | null;
  isMainContent?: boolean;
}>();

const fieldsOfLaw = computed(() => {
  if (props.fieldOfLaw) {
    return [props.fieldOfLaw, ...(props.fieldOfLaw?.ancestors ?? [])].reverse();
  }
  return [];
});
</script>
